const commonEdit = {
	border: '1px solid #00a4ff',
	outline: 'none',
	fontFamily: '\'Inconsolata\', \'Menlo\', monospace',
	fontSize: '14px',
	verticalAlign: 'middle',
	minHeight: '2em',
	margin: '0 3px',
	maxWidth: '80%',
}

const commonPreview = {
	position: 'absolute',
	/* on centre:
	 * cf https://www.w3.org/Style/Examples/007/center.en.html
	 * */
	left: '50%',
	marginRright: '-50%',
	transform: 'translate(-50%, 0)',

	padding: '10px',
	zIndex: 10,
	border: '1px solid #999',
	borderRadius: '2px',
	boxShadow: '3px 3px 5px rgba(0,0,0,0.1)',
	outline: 'none',
	background: 'white',
}

const commonRendered = {
	cursor: 'pointer',
}

export default {
	inline: {
		edit: {
			...commonEdit,
			display: 'inline-block',
			textAlign: 'center',
			padding: '5px',
			height: '2em',
		},
		preview: {
			...commonPreview,
			top: '200%', /* se réfère à la hauteur de ligne */
		},
		rendered: {
			...commonRendered,
		},
	},
	block: {
		edit: {
			...commonEdit,
			display: 'block',
			margin: '10px auto 10px',
			padding: '14px',
		},
		preview: {
			...commonPreview,
			top: 'calc(100%+1em)',
		},
		rendered: {
			...commonRendered,
		},
	},
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/formulaPlugin/components/styles.js